//
//
//
//
//

import VRuntimeTemplate from 'v-runtime-template'

export default {
	components: { VRuntimeTemplate },

	data() {
		return {
			post: this.$store.state.post,
			loadingProgress: 0, // keep from original
			postcontent: (this.$store.state.post && this.$store.state.post.content)
				? ('<div>' + this.$store.state.post.content.rendered + '</div>')
				: '<div></div>',
			// keep swiper options from original
			swiperOptions: {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				pagination: {
					el: ".swiper-pagination",
					type: "bullets",
					clickable: true,
				},
				autoplay: { delay: 4000 },
			},
		}
	},

	methods: {
		// original hooks kept (no harm if unused)
		onSwiperRedied(swiper) { console.log('Swiper redied!', swiper) },
		onSwiperSlideChangeTransitionStart() { console.log('SwiperSlideChangeTransitionStart!') },
		onSwiperClickSlide(index, reallyIndex) {
			console.log('Swiper click slide!', reallyIndex)
			const swiper = document.getElementsByClassName("swiper")[0]
			if (!swiper) return
			swiper.classList.toggle("fullscreen")
			document.body.classList.toggle("noscroll")
		},

		getExtension(string) { return string.split('.').pop() },

		// ⬇️ upgraded: supports hero cover → background Vimeo, params for normal embeds
		addVimeoParam(docElement) {
			const vimeoIframes = docElement.querySelectorAll('iframe[src*="player.vimeo.com"]')

			vimeoIframes.forEach((iframe) => {
				const isHero = !!iframe.closest('.hero-cover')
				const src = iframe.getAttribute('src') || ''
				const m = src.match(/vimeo\.com\/video\/(\d+)/) || src.match(/vimeo\.com\/(\d+)/)
				if (!m) return
				const videoId = m[1]

				if (isHero) {
					// replace entire embed with background div
					const figure = iframe.closest('figure.wp-block-embed') || iframe.closest('figure')
					const parent = figure?.parentNode
					if (!parent) return
					const isVertical = figure?.classList.contains('wp-embed-aspect-9-16')

					const bgDiv = document.createElement('div')
					bgDiv.className = isVertical ? 'vimeo-bg vimeo-vertical' : 'vimeo-bg vimeo-horizontal'
					bgDiv.setAttribute('data-vimeo-id', videoId)
					bgDiv.setAttribute('data-vimeo-background', 'true')
					bgDiv.setAttribute('data-vimeo-autoplay', 'true')
					bgDiv.setAttribute('data-vimeo-loop', 'true')
					bgDiv.setAttribute('data-vimeo-muted', 'true')

					parent.replaceChild(bgDiv, figure)
				} else {
					// non-hero: add autoplay/loop/muted params
					try {
						const url = new URL(src)
						url.searchParams.set('autoplay', '1')
						url.searchParams.set('loop', '1')
						url.searchParams.set('muted', '1')
						iframe.setAttribute('src', url.toString())
						iframe.classList.add('lazyload')
					} catch (e) {
						// fallback to string concat if URL() fails
						iframe.setAttribute('src', src + (src.includes('?') ? '&' : '?') + 'autoplay=1&loop=1&muted=1')
						iframe.classList.add('lazyload')
					}
				}
			})

			return docElement.innerHTML
		},

		AddVideoSrc(docElement) {
			const videoCollection = docElement.getElementsByTagName("video");
			const extCollection = ['mp4', 'ogv', 'webm']
			for (let i = 0; i < videoCollection.length; i++) {
				const video = videoCollection[i]
				const extension = this.getExtension(video.src)
				const filename = video.src.replace(/\.[^/.]+$/, "")
				for (const e of extCollection) {
					if (extension !== e) {
						const source = document.createElement('source');
						source.setAttribute('src', `${filename}.${e}`);
						video.appendChild(source)
					}
				}
			}
			return docElement.innerHTML
		},

		AddTransition(docElement) {
			const els = docElement.querySelectorAll("p,h2");
			for (const el of els) {
				if (!el.classList.contains('no-fade'))
					el.setAttribute('data-aos', 'fade-up')
			}
			return docElement.innerHTML
		},

		replace_content() {
			console.log('replace_content----------------------------');
			const domParser = new DOMParser();
			const htmlString = this.post?.content ? this.post.content.rendered : '';
			const docElement = domParser.parseFromString(htmlString, "text/html").documentElement;

			// keep pipeline from original, but with upgraded Vimeo handling
			this.postcontent = this.AddVideoSrc(docElement)

			const htmlString2 = this.postcontent;
			const docElement2 = domParser.parseFromString(htmlString2, "text/html").documentElement;
			this.postcontent = '<div>' + this.addVimeoParam(docElement2.getElementsByTagName("BODY")[0]) + '</div>'
		},
	},

	async mounted() {
		console.log('mounted content')
		this.replace_content()

		this.$nextTick(async () => {
			if (!process.client) return

			// ✅ Ensure Vimeo API (new)
			const ensureVimeoApi = () =>
				new Promise((resolve) => {
					const existing = document.getElementById('vimeo-bg-script')
					if (existing) return resolve()
					const s = document.createElement('script')
					s.id = 'vimeo-bg-script'
					s.src = 'https://player.vimeo.com/api/player.js'
					s.onload = () => resolve()
					document.body.appendChild(s)
				})

			await ensureVimeoApi()

			// ✅ Init background players (new)
			const heroPlayers = []

			document.querySelectorAll('.vimeo-bg').forEach((div) => {
        try {
          const player = new window.Vimeo.Player(div)
          player.setLoop(true)
          player.setMuted(true)
          heroPlayers.push({ player, el: div, isVertical: div.classList.contains('vimeo-vertical') })

          // Create mute/unmute toggle button
          const muteBtn = document.createElement('button')
          muteBtn.className = 'vimeo-unmute-btn'
          muteBtn.innerText = 'Unmute'
          div.appendChild(muteBtn)

          let isMuted = true

          muteBtn.addEventListener('click', async () => {
            try {
              if (isMuted) {
                await player.setMuted(false)
                muteBtn.innerText = 'Mute'
              } else {
                await player.setMuted(true)
                muteBtn.innerText = 'Unmute'
              }
              isMuted = !isMuted
            } catch (err) {
              console.warn('mute toggle failed', err)
            }
          })

          // If there's a placeholder image, make it the block's background
          const group = div.closest('.wp-block-group')
          const placeholder = group?.querySelector('.video-placeholder img')
          if (placeholder) {
            const url = placeholder.getAttribute('src')
            if (url) {
              group.style.background = `url(${url}) center center / cover no-repeat`
            }
            placeholder.style.opacity = '0'
            placeholder.style.transition = 'opacity 0.5s ease-in-out'
            placeholder.style.pointerEvents = 'none'
          }

          player.on('play', () => {
            div.classList.add('visible')

            const logo = document.querySelector('.hero-logo')
            const tagline = document.querySelector('.hero-tagline')

            if (logo) {
              setTimeout(() => logo.classList.add('fade-out'), 2000)
            }

            if (tagline) {
              setTimeout(() => tagline.classList.add('fade-out'), 3000)
            }

            if (placeholder) {
              placeholder.style.opacity = '0'
              setTimeout(() => (placeholder.style.display = 'none'), 1000)
            }
          })
        } catch (e) {
          console.warn('Vimeo background init failed for', div, e)
        }
      })



			// ✅ Orientation handler — only activates if both vertical and horizontal videos exist
			const hasVertical = heroPlayers.some(p => p.isVertical)
			const hasHorizontal = heroPlayers.some(p => !p.isVertical)

			if (hasVertical && hasHorizontal) {
				this._handleOrientation = () => {
					const isLandscape = window.innerWidth > window.innerHeight
					heroPlayers.forEach(({ player, el, isVertical }) => {
						const show = isLandscape ? !isVertical : isVertical
						el.style.display = show ? 'block' : 'none'
						if (show) player.play().catch(() => {})
						else player.pause().catch(() => {})
					})
				}
				this._handleOrientation()
				window.addEventListener('resize', this._handleOrientation)
			}

			// ✅ Lazy-load GLB viewer via component (new; replaces inline THREE block)
			const glbContainers = document.querySelectorAll('.glb-file')
			if (glbContainers.length) {
				const { default: ThreeModelViewer } = await import('@/components/layout/ThreeModelViewer.vue')
				const VueCtor = this.$root.constructor
				glbContainers.forEach((glbContainer) => {
					const glbUrl = glbContainer.dataset.glbUrl
					if (!glbUrl) return
					const mount = document.createElement('div')
					glbContainer.parentNode.insertBefore(mount, glbContainer.nextSibling)
					new VueCtor({ render: (h) => h(ThreeModelViewer, { props: { glbUrl } }) }).$mount(mount)
				})
			}
		})
	},

	beforeDestroy() {
		if (this._handleOrientation) window.removeEventListener('resize', this._handleOrientation)
	},

	watch: {
		// keep original autoplay-on-load for <video>
		'$store.state.post': function () {
			setTimeout(function () {
				if (document.getElementsByTagName("video").length) {
					const video = document.getElementsByTagName("video")[0];
					const isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > video.HAVE_CURRENT_DATA;
					if (!isPlaying) video.play();
				}
			}, 1000);
		}
	},
}
